// @system — shadcn/ui Checkbox (wraps @radix-ui/react-checkbox)
import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import { cn } from '@/app/lib/@system/utils'

// The button is the 24×24 hit area (WCAG 2.2 2.5.8 minimum target); the visible 16 px box is the
// inner span, styled from the root's data-state via `group-data-*`. `className` still targets the root.
/** @type {ForwardRefComponent<typeof CheckboxPrimitive.Root>} */
const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer group inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md ring-offset-brand-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
  >
    <span
      aria-hidden="true"
      className="flex h-4 w-4 items-center justify-center rounded-sm border border-primary text-brand-text-on-primary group-data-[state=checked]:bg-brand-primary group-data-[state=indeterminate]:bg-brand-primary"
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        <Check className="h-3.5 w-3.5" />
      </CheckboxPrimitive.Indicator>
    </span>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
